import React from 'react';
import { ReactComponent as ArrowLeftSVG } from '../../assets/images/icons/arrowLeft.svg';

export default function ArrowLeft(props) {
  const { theme } = props;

  return (
    <ArrowLeftSVG {...props} fill={theme.colors.consolidationComebackWrapper} className={'icon'} />
  );
}
